// Synchronizace s externími kalendáři (úkol 4.2): stav propojení, přesměrování na OAuth, výběr kalendáře,
// ruční synchronizace a odpojení.
import type {
  CalendarChoice,
  CalendarConnectUrl,
  CalendarLinkStatus,
  CalendarProvider,
  CalendarSyncResult,
  CalendarsResponse,
  UpdateCalendarLinkInput,
} from '@wac-buddy/shared'
import { api } from './client'

export function getCalendars(): Promise<CalendarsResponse> {
  return api('/me/calendars')
}

/** Adresa, na kterou se má přesměrovat celé okno (souhlas u poskytovatele). */
export function getConnectUrl(provider: CalendarProvider): Promise<CalendarConnectUrl> {
  return api(`/me/calendars/${provider}/connect-url`)
}

export function listProviderCalendars(
  provider: CalendarProvider,
): Promise<{ data: CalendarChoice[] }> {
  return api(`/me/calendars/${provider}/calendars`)
}

export function updateCalendarLink(
  provider: CalendarProvider,
  input: UpdateCalendarLinkInput,
): Promise<CalendarLinkStatus> {
  return api(`/me/calendars/${provider}`, { method: 'PUT', body: JSON.stringify(input) })
}

/** 429 při opakování do 30 sekund. */
export function syncCalendar(provider: CalendarProvider): Promise<CalendarSyncResult> {
  return api(`/me/calendars/${provider}/sync`, { method: 'POST' })
}

export function disconnectCalendar(provider: CalendarProvider): Promise<void> {
  return api(`/me/calendars/${provider}`, { method: 'DELETE' })
}
